const PREFIX = "/reducres/assessment/";

export const SET_ASSESSMENT_QUESTIONS = `${PREFIX}SET_ASSESSMENT_QUESTIONS`;
export const SET_ASSESSMENT_REPORT = `${PREFIX}SET_ASSESSMENT_REPORT`;
export const IS_LOADING = `${PREFIX}IS_LOADING`;
